<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @uploadPod="uploadPod"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchExport="batchExport"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <!-- <el-dialog
      v-if="visible"
      v-el-dialog-drag
      show-close
      visible
      width="900px"
      title="上传POD回单"
      top="10vh"
      :close-on-click-modal="false"
      :before-close="() => $refs.podForm.cancel()"
    >
      <pod-form
        ref="podForm"
        :params="params"
        @close="visible = false"
        @reload="reload"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.podForm.cancel()">取消</el-button>
        <el-button type="primary" size="small" @click="$refs.podForm.save()"
          >确认</el-button
        >
      </span>
    </el-dialog> -->
    <UploadPodDialog
      :visible.sync="uploadPodDialogOption.visible"
      :order="uploadPodDialogOption.data"
      @reload="comitOk()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import UploadPodDialog from '../upload-pod/dialog.vue'
export default {
  components: { PageMain, PageHeader, UploadPodDialog },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      uploadPodDialogOption: {
        data: {},
        visible: false,
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carrierWaybillDetailListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchExport() {
      this.$refs.main.batchExport()
    },
    uploadPod(row) {
      if (!row) return
      this.uploadPodDialogOption = {
        data: row,
        visible: true,
      }
    },
    comitOk() {
      this.$refs.main.clearCheckboxRow()
      this.reload()
    },
  },
}
</script>
